import React from 'react';
import { Box, Typography } from '@mui/material';

interface LeftSideProps {
  minHeight?: number;
}

const LeftSide: React.FC<LeftSideProps> = ({ minHeight }) => {
  return (
    <Box
      sx={{
        width: '80%',
        minHeight: minHeight,
        bgcolor: 'black',
        borderRadius: 2,
        p: 4,
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
      }}
    >
      <Typography
        gutterBottom
        sx={{
          alignSelf: 'flex-start',
          fontWeight: 'bold',
          fontSize: '90px',
          color: 'white',
        }}
      >
        Virtual Data Room
      </Typography>
      <Typography
        sx={{
          fontSize: '47px',
          color: 'grey',
          mt: 0,
        }}
      >
        Secure and streamlined document sharing for investors.
      </Typography>
    </Box>
  );
};

export default LeftSide;